import { render, staticRenderFns } from "./PreviewJobMainArticleForSp.vue?vue&type=template&id=382ba176&scoped=true"
import script from "./PreviewJobMainArticleForSp.vue?vue&type=script&lang=js"
export * from "./PreviewJobMainArticleForSp.vue?vue&type=script&lang=js"
import style0 from "./PreviewJobMainArticleForSp.vue?vue&type=style&index=0&id=382ba176&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382ba176",
  null
  
)

export default component.exports